

import { mdiCheck } from '@mdi/js'
import { mapState } from 'vuex'
import ObfuscateTooltip from '@/components/catalog/ObfuscateTooltip'

export default {
  components: { ObfuscateTooltip },
  props: {
    attributeSetName: {
      type: String,
      default: ''
    },
    attributeGroupName: {
      type: String,
      default: ''
    },
    attributes: {
      type: Object,
      default: () => Object()
    },
    merchantAcceptedByCm24: {
      type: Boolean,
      default: false
    },
    sortedAlphabetically: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    mdiCheck
  }),
  computed: {
    ...mapState('upload', {
      uploadAttributes: state => state.attributes,
      uploadAttributesDe: state => state.attributesDe
    }),
    filtered () {
      const filtered = []
      for (const attributeId of Object.keys(this.attributes)) {
        const obj = this.attributes[attributeId]

        // We keep this for backward compatibility ... not necessary anymore for reindexed products
        if (obj.attributeCode === 'popup_roof' ||
          obj.attributeCode === 'chassis'
        ) {
          continue
        }

        if ((!this.attributeGroupName || obj.attributeGroupName === this.attributeGroupName) &&
          obj.attributeSetName === this.attributeSetName) {
          filtered.push(obj)
        }
      }

      if (this.sortedAlphabetically) {
        filtered.sort(function (a, b) {
          const as = a.label
          const bs = b.label

          return as - bs
        })
      } else {
        filtered.sort(function (a, b) {
          const as = a.sortOrder
          const bs = b.sortOrder

          return as - bs
        })
      }

      return filtered
    }
  },

  methods: {
    getLabel (attribute) {
      if (attribute.attributeCode in this.uploadAttributes) {
        return this.uploadAttributes[attribute.attributeCode].label
      } else {
        return attribute.label
      }
    },

    getValue (attribute) {
      const localizedAttribute = attribute.attributeCode in this.uploadAttributes
        ? this.uploadAttributes[attribute.attributeCode]
        : attribute

      if (attribute.frontendInput === 'multipleselect') {
        return localizedAttribute?.options?.filter(option => attribute.value.includes(option.optionId))
          .map(option => option.label)
          .join(', ')
      } else if (attribute.optionLabel != null) {
        const foundOption = localizedAttribute?.options?.find(option => attribute.value === option.optionId)
        const value = foundOption ? foundOption?.label : attribute.optionLabel
        return this.format(attribute.attributeCode, value)
      } else {
        return this.format(attribute.attributeCode, attribute.value)
      }
    },

    format (attributeCode, value) {
      return this.$eavFormatter.formatUploadAttribute(attributeCode, value)
    }
  }

}
